import React from "react";
import PublicHeader from "../headers/PublicHeader";
import { Theme } from "@material-ui/core/styles";
import { fade } from "@material-ui/core/styles";
import makeStyles from "@material-ui/core/styles/makeStyles";
import Background from "../../../../assets/img/orange-arrow-signs.jpg";

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    backgroundColor: theme.palette.background.default,
    [theme.breakpoints.up("md")]: {
      backgroundImage: `url(${Background})`,
      backgroundSize: "cover",
    },
  },
  bg: {
    minHeight: "100vh",
    backgroundColor: fade(theme.palette.primary.dark, 0.9),
    [theme.breakpoints.down("sm")]: {
      backgroundColor: "transparent",
      backgroundImage: theme.palette.background.paper,
    },
  },
}));

const PublicLayout = ({ children }) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className={classes.bg}>
        <PublicHeader />
        {children}
      </div>
    </div>
  );
};

export default React.memo(PublicLayout);
